import { Tag, Box, Flex, Icon } from '@chakra-ui/react';
import { ViewIcon, TimeIcon, SettingsIcon, CopyIcon } from '@chakra-ui/icons';
import { ChassisInfo, OsInfo, SystemInfo } from '../../types/stats';
import { formatUptime } from '../../utils/stats';
import { FaDesktop, FaMicrochip, FaPause, FaPlay } from "react-icons/fa";
import { FiHardDrive } from 'react-icons/fi';

interface SystemInfoBarProps {
  chassisData: ChassisInfo; 
  systemData: SystemInfo; 
  osData: OsInfo;
  timestamp: number;
  paused: boolean;
}

export function SystemInfoBar({ osData,chassisData, systemData, timestamp, paused }: SystemInfoBarProps) {
  const uptime = formatUptime(timestamp);

  return (
    <Box borderWidth="1px" borderRadius="2xl" p={4} position="relative">
      {paused && (
        <Tag borderRadius="2xl" px="2" py="1" position="absolute" top={2} right={2} colorScheme="yellow">Paused</Tag>
      )}
      
      <Flex flexWrap="wrap" gap={2} justifyContent={{ base: 'center', sm: 'start' }}>
        <Tag borderRadius="2xl" px="2" py="1" fontFamily="mono" colorScheme="gray" display="flex" alignItems="center" gap={1} fontSize="xs">
          <Icon as={FaDesktop} />
          {osData.platform}
        </Tag>
        
        <Tag borderRadius="2xl" px="2" py="1" fontFamily="mono" colorScheme="gray" display="flex" alignItems="center" gap={1} fontSize="xs">
          <Icon as={FiHardDrive} />
          {osData.distro} {osData.release}
        </Tag>
        
        <Tag borderRadius="2xl" px="2" py="1" fontFamily="mono" colorScheme="gray" display="flex" alignItems="center" gap={1} fontSize="xs">
          <Icon as={FaMicrochip} />
          {osData.arch}
        </Tag>

        <Tag borderRadius="2xl" px="2" py="1" fontFamily="mono" colorScheme="gray" display="flex" alignItems="center" gap={1} fontSize="xs">
          <Icon as={FaDesktop} />
          {chassisData.type}
        </Tag>

        <Tag borderRadius="2xl" px="2" py="1" fontFamily="mono" colorScheme="gray" display="flex" alignItems="center" gap={1} fontSize="xs">
          {systemData.manufacturer} - {systemData.model}
        </Tag>

        {systemData.virtual && 
        <Tag borderRadius="2xl" px="2" py="1" fontFamily="mono" colorScheme="gray" display="flex" alignItems="center" gap={1} fontSize="xs">
           Virtual Machine
        </Tag>
        }
        
        <Tag borderRadius="2xl" px="2" py="1" fontFamily="mono" colorScheme="gray" display="flex" alignItems="center" gap={1} fontSize="xs">
          <Icon as={TimeIcon} />
          {uptime} uptime
        </Tag>
        
        <Tag borderRadius="2xl" px="2" py="1" colorScheme="gray" fontFamily="mono" fontSize="xs">
          Last update: {new Date(timestamp).toLocaleTimeString()}
        </Tag>
      </Flex>
    </Box>
  );
}
